import React, { useContext, useState } from "react";
import { Button, Modal, Row, Col, Tooltip, Input } from "antd";
import {
  FileAddOutlined,
  PlusSquareOutlined,
  SaveOutlined,
  DownloadOutlined,
  DeleteOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";

import { generateClient } from "aws-amplify/data";
import type { Schema } from "../../amplify/data/resource";
import { SquareDataContext } from "./contexts/SquareData";
import { TodoListDataContext } from "./contexts/TodoListData";
import { LayerDataContext } from "./contexts/LayerData";
import LayerBreadcrumbs from "./LayerBreadcrumbs";
import { ConsoleLogger } from "aws-amplify/utils";

const client = generateClient<Schema>();

const MainMenu = () => {
  const [projectCode, setProjectCode] = useState("");
  const { squareData, setSquareData } = useContext(SquareDataContext);
  const { todoListData, setTodoListData } = useContext(TodoListDataContext);
  const { layerData, setLayerData, currentPath, currentPathIndex } =
    useContext(LayerDataContext);

  const loadProject = async () => {
    if (!projectCode) return;
    try {
      const res = await client.models.LignaProject.get({
        id: projectCode,
      });
      const proj = res.data;
      console.log(res);
      if (proj) {
        const { layerData, squareData, todoListData } = JSON.parse(proj.data);
        setLayerData(layerData);
        setSquareData(squareData);
        setTodoListData(todoListData);
      } else {
        Modal.info({ title: "Kein Projekt gefunden" });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSave = async () => {
    // localStorage.setItem("squareDataSave", JSON.stringify(squareData));
    // localStorage.setItem("layerDataSave", JSON.stringify(layerData));
    // localStorage.setItem("todoListDataSave", JSON.stringify(todoListData));
    if (!projectCode) {
      Modal.error({ title: "Bitte erst Projekt-Code eingeben" });
      return;
    }
    const payload = JSON.stringify({ layerData, squareData, todoListData });
    try {
      // Prüfen, ob es das Projekt bereits gibt
      const existing = await client.models.LignaProject.get({
        id: projectCode,
      });
      console.log(existing);
      console.log(payload);
      if (existing.data) {
        await client.models.LignaProject.update({
          id: projectCode,
          data: payload,
        });
      } else {
        await client.models.LignaProject.create({
          id: projectCode,
          data: payload,
        });
      }
      Modal.success({ title: "Projekt gespeichert" });
    } catch (err) {
      console.error(err);
      Modal.error({ title: "Speichern fehlgeschlagen" });
    }
  };

  const handleClear = () => {
    Modal.confirm({
      title: "Soll wirklich alles gelöscht werden?",
      onOk: () => {
        localStorage.clear();
        window.location.reload();
      },
    });
  };

  const handleAddSquare = () => {
    const newSquare = {
      id: `tr${squareData.length}`,
      text: "- Insert Text -",
      width: 200,
      height: 160,
      x: 20,
      y: 20,
      layer: currentPath[currentPathIndex].layer,
      title: "- Title -",
    };
    setSquareData([...squareData, newSquare]);
  };

  const handleAddTodoList = () => {
    const newTodoList = {
      id: `tdl${todoListData.length}`,
      text: "- Insert Text -",
      width: 200,
      height: 160,
      x: 20,
      y: 20,
      layer: currentPath[currentPathIndex].layer,
      title: "- Title -",
    };
    setTodoListData([...todoListData, newTodoList]);
  };

  const handleAddLayer = () => {
    const newLayer = {
      id: `lr${layerData.length}`,
      text: "- Insert Text -",
      width: 100,
      height: 100,
      x: 20,
      y: 20,
      layer: currentPath[currentPathIndex].layer,
      color: `#${(((1 << 24) * Math.random()) | 0).toString(16)}`,
    };
    setLayerData([...layerData, newLayer]);
  };

  return (
    <Row gutter={[16, 16]}>
      <Col span={6}>
        <Input
          placeholder="Projekt-Code"
          value={projectCode}
          onChange={(e) => setProjectCode(e.target.value)}
        />
      </Col>
      <Col span={3}>
        <Tooltip title="Neue Ebene">
          <Button icon={<FileAddOutlined />} onClick={handleAddLayer} />
        </Tooltip>
        <Tooltip title="Textbox">
          <Button icon={<PlusSquareOutlined />} onClick={handleAddSquare} />
        </Tooltip>
        <Tooltip title="Todo Liste">
          <Button icon={<FileDoneOutlined />} onClick={handleAddTodoList} />
        </Tooltip>
      </Col>
      <Col span={3}>
        <Button icon={<DownloadOutlined />} onClick={loadProject} />
        <Button icon={<SaveOutlined />} onClick={handleSave} />
        <Button icon={<DeleteOutlined />} danger={true} onClick={handleClear} />
      </Col>
      <Col span={12}>
        <LayerBreadcrumbs />
      </Col>
    </Row>
  );
};

export default MainMenu;
